
  import { Component, Vue } from 'vue-property-decorator';
  import { Client, MissedInvoiceJobItemModel } from '@/services/api.service';
  import toJobItemTypeFormatter from '@/filters/jobitemtype.formatter';
  import toStatusFormatter from '@/filters/status.formatter';
  import toDateFormatter from '@/filters/todate.formatter';

  @Component({
    filters: {
      toDate: toDateFormatter,
      toJobItemType: toJobItemTypeFormatter,
      toStatus: toStatusFormatter
    }
  })
  export default class MissedInvoicesList extends Vue {
    private rows: MissedInvoiceJobItemModel[] = [];
    private isLoading: boolean = false;
    private searchCriteria: string = '';

    protected mounted() {
      this.fetchMissedInvoices();
    }

    private async fetchMissedInvoices() {
      this.isLoading = true;
      this.rows = [];

      const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
      try {
        const data = await clientService.getMissedInvoiceJobItems(this.searchCriteria || '');
        this.rows = data || [];
      } finally {
        this.isLoading = false;
      }
    }

    private getStatus(value: number | undefined): string {
      return toStatusFormatter(value || 0).toLowerCase();
    }
  }
